import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Grid,
  Paper,
  Button,
  TextField,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";

export default function AdminLeadDetailPage() {
  const { id } = useParams();
  const [lead, setLead] = useState(null);
  const [note, setNote] = useState("");

  const load = useCallback(
    () => apiClient.request(`/api/admin/leads/${id}`).then(setLead),
    [id]
  );

  useEffect(() => {
    load();
  }, [load]);

  const runAction = async (action) => {
    await apiClient.request(`/api/admin/leads/${id}/actions`, {
      method: "POST",
      body: JSON.stringify({ action }),
    });
    load();
  };

  const addNote = async () => {
    if (!note.trim()) return;
    await apiClient.request(`/api/admin/leads/${id}/notes`, {
      method: "POST",
      body: JSON.stringify({ content: note }),
    });
    setNote("");
    load();
  };

  if (!lead) return <Typography>Chargement...</Typography>;

  return (
    <>
      <SEO title="Admin Lead | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 2 }}>Fiche lead</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography>Email: {lead.email}</Typography>
            <Typography>Nom: {`${lead.first_name || ""} ${lead.last_name || ""}`}</Typography>
            <Typography>Source: {lead.source}</Typography>
            <Typography>Statut: {lead.status}</Typography>
            <Typography>Sequence: {lead.sequence_status}</Typography>
            <Typography>RDV: {lead.rdv_booked ? "Oui" : "Non"}</Typography>
            <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Button size="small" variant="outlined" onClick={() => runAction("pause_sequence")}>Pause sequence</Button>
              <Button size="small" variant="outlined" onClick={() => runAction("resume_sequence")}>Reprendre sequence</Button>
              <Button size="small" variant="outlined" onClick={() => runAction("mark_contacted")}>Marquer contacte</Button>
              <Button size="small" variant="outlined" onClick={() => runAction("mark_qualified")}>Marquer qualifie</Button>
              <Button size="small" variant="outlined" onClick={() => runAction("mark_client")}>Marquer client</Button>
              <Button size="small" color="warning" variant="outlined" onClick={() => runAction("archive")}>Archiver</Button>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Ajouter une note</Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
            <Button sx={{ mt: 1 }} variant="contained" onClick={addNote}>Ajouter</Button>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Historique</Typography>
            <List dense>
              {lead.events?.map((row) => (
                <ListItem key={row.id}>
                  <ListItemText
                    primary={row.label}
                    secondary={new Date(row.created_at).toLocaleString()}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Emails</Typography>
            <List dense>
              {lead.emails?.map((row) => (
                <ListItem key={row.id}>
                  <ListItemText
                    primary={`${row.email_type} - ${row.status}`}
                    secondary={row.sent_at ? new Date(row.sent_at).toLocaleString() : "-"}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Notes</Typography>
            <List dense>
              {lead.notes?.map((row) => (
                <ListItem key={row.id}>
                  <ListItemText
                    primary={row.content}
                    secondary={new Date(row.created_at).toLocaleString()}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
